import { AmplifyAuthWrapper } from './amplifyAuthWrapper';
import AuthApi from './authApi';
import { initialize as initializeEventlistener } from './eventlistener';

const amplifyAuthWrapper = new AmplifyAuthWrapper();
const authApi = new AuthApi({ amplifyAuthWrapper });

initializeEventlistener({ amplifyAuthWrapper });

export { authApi as api };
